export default __webpack_public_path__ + "static/media/milestone 1100.12655f06.svg";